/*
 * @Author: sunwang
 * @Date: 2020-08-03 13:33:53
 */
import store from '../store';
import Cookies from 'js-cookie';
import { userInfo } from '_api/common';

export async function loginInterface() {
  let { uid } = inspectLogin();
  if (!uid) {
    return;
  }
  let key = store.state.app.key;
  let param = { uid, key };
  let { obj, code } = await userInfo(param);
  await store.commit('SET_USER', obj);
  if (!obj.uid) {
    let tempObj = {
      param: param,
      obj,
      code
    };
    window.FT_REPORT.reportEvent({ us: JSON.stringify(tempObj) }, true);
    return;
  }
  let url = '/report';
  let submitList = {};
  submitList.uid = obj.uid;
  submitList.newUser = new Date(new Date(obj.firstLogin).getTime()).toDateString() === new Date(new Date().getTime()).toDateString() ? '1' : '0';
  submitList.source = key;
  submitList.vipState = obj.vipState;
  submitList.vipLevel = obj.vipLevel;
  submitList.login = new Date().getTime();
  let params = [
    {
      headers: {
        time: new Date().getTime(),
        m: 'login'
      },
      body: JSON.stringify([submitList])
    }
  ];
  console.log(',,,,,', JSON.stringify(params));
  FT_BASE.xhr({
    method: 'POST',
    url: url,
    data: JSON.stringify(params)
  });
  Cookies.set('firstLogin', '1');
}

export function duraction(to, form, datePath) {
  if (window.FT_REPORT) {
    datePath[to.path] = new Date().getTime();
    console.log(form, to);
    if (form.path === '/' && to.path === '/home') {
      if (!sessionStorage.getItem('time') || !JSON.parse(sessionStorage.getItem('time'))[to.path]) {
        sessionStorage.setItem('time', JSON.stringify(datePath));
      }
    }
    if (form.path !== '/' && form.meta.alias) {
      sessionStorage.setItem('time', JSON.stringify(datePath));

      let formtime = JSON.parse(sessionStorage.getItem('time'))[form.path];
      let totime = JSON.parse(sessionStorage.getItem('time'))[to.path];
      let difftime = Math.round((totime - formtime) / 1000);
      // debugger;
      window.FT_REPORT.report('movepage', {
        duration: difftime,
        group: form.meta.alias
      });
    }
  }
}
export function inspectLogin() {
  try {
    let userInfo = PLUGIN.getUserInfo();
    if (userInfo) {
      let { uid, uname } = userInfo; //PLUGIN.store.getData().userData;
      console.log('uname: ', uname);
      console.log('uid: ', uid);
      store.commit('SET_UID', uid);
      store.commit('SET_NAME', decodeURIComponent(uname));
      return { uid };
    } else {
      store.commit('SET_UID', '');
      store.commit('SET_NAME', '');
      store.commit('SET_IS_LOGIN', false);
      return { uid: '' };
    }
  } catch (err) {
    store.commit('SET_UID', '');
    store.commit('SET_NAME', '');
    store.commit('SET_IS_LOGIN', false);
  }
}
export function inspectUa() {
  let isApp = PLUGIN.isApp;
  let isWx = PLUGIN.isWx;

  store.commit('SET_ISWX', isWx);
  if (isApp || isWx) {
    store.commit('SET_ISSHOW', false);
  } else {
    store.commit('SET_ISSHOW', true);
  }
}



// WEBPACK FOOTER //
// src/utils/login.js